import CustomTable, { TableHeaderData } from '../reusable/CustomTable';
import { columnsOf, formatLeaf, MetricRow, prettifyKey } from './metricTable';

const ChatMetricResult = ({ rows }: { rows: MetricRow[] }) => {
  const columns = columnsOf(rows);
  const headers: TableHeaderData<Record<string, string>>[] = columns.map((key) => ({
    key,
    label: prettifyKey(key),
  }));
  const body = rows.map((row, index) => {
    const cells: Record<string, string> = { id: String(index) };
    columns.forEach((key) => {
      cells[key] = formatLeaf(row[key]);
    });
    return cells;
  });

  return <CustomTable tableHeaderData={headers} tableBodyData={body} size="small" />;
};

export default ChatMetricResult;
